import { z } from 'zod'

export const benefitAndVoucherManagementGetBenefitCountSchema = z.object({
  total: z.number(),
  freeAirlineTicket: z.number(),
  businessCard: z.number(),
  mileageRedemptionVoucher: z.number(),
  purchaseDiscountCode: z.number(),
  flightVoucher: z.number(),
  upgradeVoucher: z.number(),
  airportPrivileges: z.number(),
  bundleProducts: z.number()
})

export interface BenefitAndVoucherManagementGetBenefitCount
  extends z.infer<typeof benefitAndVoucherManagementGetBenefitCountSchema> {}
